var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnFlag = function SvgEnFlag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uk",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.71 8.17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d70e29;}.cls-2{fill:#efefef;}.cls-3{fill:#1f54a1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m.13.26h11.46v7.64H.13V.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.57.26h-1.43v3.1H.13v1.43h5.01v3.1h1.43v-3.1h5.01v-1.43h-5.01V.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m8.94,5.41l2.64,1.47v-1.47h-2.64Zm-1.84,0l4.48,2.49v-.7l-3.22-1.79h-1.27Zm3.29,2.49l-3.29-1.83v1.83h3.29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m7.1,5.41l4.48,2.49v-.7l-3.22-1.79h-1.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.1,5.41l4.48,2.49v-.7l-3.22-1.79h-1.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2.15,5.41L.13,6.53v-1.12h2.02Zm2.46.32v2.17H.7l3.91-2.17Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.34,5.41L.13,7.2v.7l4.48-2.49h-1.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2.77,2.75L.13,1.29v1.47h2.64Zm1.84,0L.13.26v.7l3.22,1.79h1.27ZM1.32.26l3.29,1.83V.26H1.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.61,2.75L.13.26v.7l3.22,1.79h1.27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.61,2.75L.13.26v.7l3.22,1.79h1.27Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m9.56,2.75l2.02-1.12v1.12h-2.02Zm-2.46-.32V.26h3.91l-3.91,2.17Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.37,2.75l3.22-1.79V.26l-4.48,2.49h1.27Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "en_flag.d2193a0a4eeb4db75e7112c4e7ebe4c9.svg";